import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Route, Routes } from 'react-router-dom';
import MainNav from 'core/containers/main-nav-container';
import classes from './core-view.scss';
import { isMobileOnly, isTablet } from 'react-device-detect';
import 'styles/core.scss';
import AlertAuthWarning from 'containers/alert-auth-warning-container';
import AlertAuthExpired from 'containers/alert-auth-expired-container';
import { useIntl, defineMessages } from 'react-intl';
import mt from 'core/message-translations';
import Unauthorized from 'routes/unauthorized/containers/unauthorized-container';
import ErrorView from 'routes/error/containers/error-container';
import ClientInfo from 'routes/clients/containers/client-list-container';
import RoleInfo from 'routes/roles/containers/role-list-container';
import ScopeInfo from 'routes/scopes/containers/scope-list-container';
import ClientEdit from 'routes/clients/clientedit/containers/client-edit-container';
import ConfirmDialog from 'containers/confirm-dialog-container';
import SideNav from "core/containers/side-nav-container";
import { Box } from '@mui/material';
import Notification from "./notification-view";
import MobileView from './mobile-view';

const Core = (props) => {
  const intl = useIntl();
  return (
    <React.Fragment>
      {(isMobileOnly || isTablet) ? <MobileView /> :
      <Box
        className="app-container"
        id="app-container">
        <Box className="app-container-inner">
          {props.confirmDialog &&
          props.confirmDialog.yesCallbackFn &&
          props.confirmDialog.noCallbackFn &&
            <ConfirmDialog />}
          {props.alertAuthWarningIsVisible && <AlertAuthWarning />}
          {props.alertAuthExpiredIsVisible && <AlertAuthExpired />}
          <MainNav />
          <Box className={classes["fluidAppContainer"]}>
            <SideNav />
            <Box className={classes['mainDisplay']}>
              {props.toastrMessage &&
              props.toastrMessage.type &&
              props.toastrMessage.messageId &&
                <Box className={classes["notificationContainer"]}>
                  <Notification
                    toastrType={props.toastrMessage.type}
                    toastrMessage={intl.formatMessage(mt[props.toastrMessage.messageId], props.toastrMessage.params)}
                    toastrMessageId={props.toastrMessage.messageId}
                  />
                </Box>}
              <Routes>
                <Route path="/" element={<Navigate to="/clients" replace />} />
                <Route
                  exact
                  path="/clients/clientcreate"
                  element={<ClientEdit />}
                />
                <Route
                  exact
                  path="/clients/clientedit/:clientId?"
                  element={<ClientEdit />}
                />
                <Route
                  exact
                  path="/clients"
                  element={<ClientInfo />}
                />
                {props.clientIsAdmin && (
                  <Route
                    exact
                    path="/roles"
                    element={<RoleInfo />}
                  />
                )}
                {props.clientIsAdmin && (
                  <Route
                    exact
                    path="/scopes"
                    element={<ScopeInfo />}
                  />
                )}
                <Route
                  exact
                  path="/unauthorized"
                  element={<Unauthorized />}
                />
                <Route
                  exact
                  path="/error"
                  element={<ErrorView />}
                />
              </Routes>
            </Box>
          </Box>
        </Box>
      </Box>}
    </React.Fragment>
  );
};

Core.propTypes = {
  alertAuthWarningIsVisible: PropTypes.bool,
  alertAuthExpiredIsVisible: PropTypes.bool,
  toastrMessage: PropTypes.shape({
    type: PropTypes.string,
    messageId: PropTypes.string,
    params: PropTypes.object,
  }),
  confirmDialog: PropTypes.shape({
    yesCallbackFn: PropTypes.func,
    noCallbackFn: PropTypes.func,
    dynamicVal: PropTypes.string
  }),
  clientIsAdmin: PropTypes.bool,
};

export default Core;
